import moment from 'moment';
import { UserDto } from '../../auth/user.dto';
import { ItemHistorizable } from '../../shared/models/itemHistorizable';

export class ReferentDto implements ItemHistorizable {
  public id: number;
  public beginDate: Date;
  public endDate: Date;
  public user: UserDto;
  public type: string;
  public beneficiaryId: number;
  public historized: boolean;

  public static fromJson(json: any): ReferentDto {
    if (json) {
      return {
        id: json.id,
        beginDate: json.beginDate ? moment(json.beginDate).toDate() : undefined,
        endDate: json.endDate ? moment(json.endDate).toDate() : undefined,
        user: json.user,
        type: json.type,
        beneficiaryId: json.beneficiaryId,
        historized: json.historized,
      } as ReferentDto;
    }
  }
}
